declare const Tally: unknown;

import { Embed } from './embed_abstract';

export class TallyFormEmbed extends Embed {
    private iFrameEl: HTMLIFrameElement;
    private config = {
        'data-tally-src': `${this.url}`,
        loading: 'lazy',
        width: '100%',
        height: '300',
        frameborder: '0',
        marginheight: '0',
        marginwidth: '0'
    };

    addIframeEl(): void {
        this.iFrameEl = document.createElement('iframe');

        Object.entries(this.config).forEach(([option, value]) => {
            this.iFrameEl.setAttribute(option, value);
        });

        this.placeholder?.replaceWith(this.iFrameEl);
    }

    async load(): Promise<this> {
        this.addIframeEl();
        await this.api();
        await this.build();
        return this;
    }

    build(): Promise<void> {
        return new Promise((resolve) => {
            if (typeof Tally === 'undefined') {
                resolve();
                return;
            }
            Tally.loadEmbeds();
            window.addEventListener('message', (e) => {
                if (e.origin !== 'https://tally.so') {
                    return;
                }

                try {
                    const data = JSON.parse(String(e.data));
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    if (typeof data === 'object' && 'event' in data && data.event === 'Tally.FormLoaded') {
                        resolve();
                    }
                } catch {
                    // this is probably not the event we're looking for
                }
                resolve();
            });
        });
    }

    api(): Promise<void> {
        return new Promise((resolve) => {
            this.addScript('https://tally.so/widgets/embed.js', () => {
                resolve();
            });
        });
    }
}
